export default __webpack_public_path__ + "img/381a3c50153b0b33a5a88dc257b6a3b0.svg";